import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalHeadAndClose from "../common/ModalHeadAndClose";
import SelectDropdown from "../../components-react/SelectDropdown";
import { Button } from "react-bootstrap";
import { editTableStatuses } from "../../../exports/ProfitShareData";
import { createNewCTOHead } from "../../../redux/reducers/postApiSlice";
import { fetchCTOHead } from "../../../redux/reducers/apiSlice";
import { toast } from "react-toastify";
import { selectAuth } from "../../auth/auth.selector";

function AddCtoHead({ onClose }) {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  // const { ctoHeadData, loading, error } = useSelector((state) => state.api);

  const initialCtoHeadValues = {
    headName: "",
    selectedCtoHeadStatus: "",
  };
  const [ctoHeadFormValues, setCtoHeadFormValues] =
    useState(initialCtoHeadValues);

  const onSubmitCtoDetails = (e) => {
    e.preventDefault();

    const ctoHeadDetails = {
      head_name: ctoHeadFormValues.headName,
      status: ctoHeadFormValues.selectedCtoHeadStatus.value,
    };

    const payload = JSON.stringify(ctoHeadDetails);

    handleCreateCTOHead(payload, decryptedText?.token);
  };

  const handleCreateCTOHead = async (userData, authToken) => {
    try {
      const result = await dispatch(createNewCTOHead({ userData, authToken }));

      if (createNewCTOHead.fulfilled.match(result)) {
        const successMessage = result.payload.message;
        toast.success(successMessage);
        dispatch(fetchCTOHead({ token: decryptedText?.token }));
        setCtoHeadFormValues(initialCtoHeadValues);
        onClose();
      } else {
        const errorMessage = result.error.message;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.log("handleCreateCTOHead ERROR => ", error);
    }
  };

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <div className="outerContainer">
      <div className="addCtoHeadContainer">
        <ModalHeadAndClose title="Create New CTO Head" onClose={onClose} />

        <form className="formContainer">
          <div className="formRow">
            <div className="formRowField">
              <label htmlFor="head-name" className="formRowFieldLabel">
                Head Name
              </label>

              <input
                type="text"
                placeholder="Enter Name Here"
                className="formInput"
                value={ctoHeadFormValues.headName}
                onChange={(e) =>
                  setCtoHeadFormValues({
                    ...ctoHeadFormValues,
                    headName: e.target.value,
                  })
                }
              />
            </div>

            <div className="formRowField">
              <label htmlFor="head-status" className="formRowFieldLabel">
                Head status
              </label>

              <SelectDropdown
                options={editTableStatuses}
                selectedOption={ctoHeadFormValues.selectedCtoHeadStatus}
                setSelectedOption={(selectedValue) =>
                  setCtoHeadFormValues({
                    ...ctoHeadFormValues,
                    selectedCtoHeadStatus: selectedValue,
                  })
                }
                name="From The List"
              />
            </div>
          </div>

          <div className="formButtonContainer">
            <Button variant="danger" onClick={onSubmitCtoDetails}>
              Save
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCtoHead;
